// Copyright (c) 2016 Deere & Company

const showFileUploadStatuses = [
    'DMGD',
    'EOOS',
    'LCUK',
    'STL1',
    'STLP',
    'STNR'
];

export default showFileUploadStatuses;



// WEBPACK FOOTER //
// ./src/product/status-change-request/utils/show-file-upload-statuses.js